/**
 * Themes queries
 */

import gql from 'graphql-tag'

export const themesQuery = gql`
  query GetThemesByProduct($id: Int!) {
    themes: getThemesByProduct(productId: $id) {
      id
      image
      name
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterTheme/data.ts